import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { TedarikciEditComponent } from './tedarikci-edit.component';
import { TedarikciKartComponent } from './tedarikci-kart.component';
import { TedarikciKartSadeComponent } from './tedarikci-kart-sade.component';

@DinamikBilesen({
  id: 'tedarikci',
  baslik: 'Tedarikçi',
  aciklama: 'Tedarikçi/firma kaydı',
  ikon: 'shop',
  kategori: 'personel',
})
class Tedarikci {
  paylas_kutusu = TedarikciEditComponent;
  paylasilmis_kart = TedarikciKartComponent;
  paylasilmis_kart_sade = TedarikciKartSadeComponent;
}
